/**
 * Utility for treatment/product approval status checks and badges.
 *
 * Uses case-insensitive includes matching so admin label variations
 * (e.g. "actif", "ACTIF", "Actif ") all work.
 */

const statusIncludes = (statusName, keyword) =>
  statusName?.toLowerCase().includes(keyword.toLowerCase());

// ── Product validity (for filtering products in treatment columns) ──

export const isApprovalValid = (record) => {
  const statusName = record?.approval_status?.name;
  if (!statusName) return false;

  if (statusIncludes(statusName, 'actif') && !statusIncludes(statusName, 'fin')) return true;

  if (statusIncludes(statusName, "fin d'homologation") || statusIncludes(statusName, 'urgence')) {
    const endDate = record?.approval_end_date;
    if (!endDate) return false;
    return new Date(endDate) >= new Date(new Date().toISOString().split('T')[0]);
  }

  return false;
};

export const filterValidTreatmentProducts = (treatmentProducts) =>
  treatmentProducts?.filter((tp) => isApprovalValid(tp?.product)) || [];

// ── Treatment status badges (for details column) ──

/**
 * Returns an array of badge objects for a treatment record.
 * Each badge: { key, labelKey, color }
 *   - labelKey is the i18n key under 'treatment-search|'
 *   - color is the badge background color
 *
 * Rules:
 *   Nouveau  = Actif + approval_start_date < 1 year ago
 *   Fin      = Fin d'homologation
 *   Urgence  = Urgence
 */
export const getTreatmentBadges = (record) => {
  const statusName = record?.approval_status?.name;
  if (!statusName) return [];

  const badges = [];

  if (statusIncludes(statusName, 'actif') && !statusIncludes(statusName, 'fin')) {
    const startDate = record?.approval_start_date;
    if (startDate) {
      const oneYearAgo = new Date();
      oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
      if (new Date(startDate) >= oneYearAgo) {
        badges.push({ key: 'nouveau', labelKey: 'table.nouveau', tooltipKey: 'table.nouveau_tooltip', bgColor: 'rgb(8, 151, 156)', textColor: '#FFFFFF' });
      }
    }
  }

  if (statusIncludes(statusName, "fin d'homologation")) {
    badges.push({ key: 'fin', labelKey: 'table.fin', tooltipKey: 'table.fin_tooltip', bgColor: 'rgb(255, 255, 184)', textColor: 'rgba(0, 0, 0, 0.85)' });
  }

  if (statusIncludes(statusName, 'urgence')) {
    badges.push({ key: 'urgence', labelKey: 'table.urgence', tooltipKey: 'table.urgence_tooltip', bgColor: '#FF4D4F', textColor: '#FFFFFF' });
  }

  return badges;
};
